var React = require('react');

function CaretInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"#909F9E","fillRule":"nonzero","d":"M1.414 8.243l6.363-6.364 6.365 6.364.707-.707-6.364-6.364-.707-.708-7.07 7.072.706.707z"}));
}

CaretInline.defaultProps = {"width":"15","height":"9","viewBox":"0 0 15 9"};

module.exports = CaretInline;

CaretInline.default = CaretInline;
